import { Box, Text } from '@chakra-ui/react'
import React from 'react'

const LatestActivities = () => {
  return (
        <Box mt={"7%"}>
            <Text mb={"2%"}>Latest Activities</Text>
            <Box border={"1px solid gray"} width="80%"  height="250px">
                
            </Box>
        </Box>
  )
}

export default LatestActivities